import React from 'react';
import type { Props as InlineCreateFormProps } from '@atlassian/jira-issue-table-inline-issue-create/src/ui/inline-create-form/index.tsx';
import { IssueCreateCell } from './issue-create-cell/index.tsx';

export type Props = Omit<InlineCreateFormProps, 'onCreateIssue' | 'contextualFields'> & {
	isFormVisible: boolean;
	itemsConnectionId: string;
	parentIssueAri: string;
	siblingIssueId?: string;
	parentItemConnectionId: string;
};

/**
 * Use '@atlassian/jira-issue-table-hierarchy/src/ui/child-issue-create-row/index.tsx' instead
 * @deprecated delete when jira_list_hierarchy_extraction is cleaned up
 */
export const ChildIssueCreateRow = ({ isFormVisible, ...props }: Props) => {
	return (
		isFormVisible && (
			<tr>
				<IssueCreateCell {...props} />
			</tr>
		)
	);
};
